import {
  MonthViewTheme,
  styles,
  variants,
  multiVariantStyles
} from '#PRIVATE_MonthView/themes/MonthViewStyles.css';

const MonthViewStableTheme: MonthViewTheme = {
  multiVariantStyles,
  variants,
  styles
};

export { MonthViewStableTheme };
